import * as moment from 'moment';
import 'moment-timezone';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SocketService } from '../../services/SocketService';
import { OrderPipe } from '../../helpers/order.pipe';
import { StateService } from '../../services/state.service';
import { DataexchangeService } from '../../services/dataexchange.service';
import { Subscription } from 'rxjs';
import { TradeHistoryColumns } from '../../models/trade-history.model';
import { getCurrencyPairsSelector, getTradesSelector } from '../../store/state/selectors/matchboard.selectors';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../store/state/reducers/matchboard.reducers';
import { CurrencyDto } from '../../models/CurrencyDto';
import { Json } from '../../models/Json';

@Component({
  selector: 'app-blotter',
  templateUrl: './blotter.component.html'
})
export class BlotterComponent implements OnInit, OnDestroy {

  subscriptions: Array<Subscription>;

 // TradeHistoryColumns: TradeHistoryColumns[] = [];
  TradeHistoryColumns: TradeHistoryColumns[] = [];

  public today = Date.now();

 // order: string = 'timestamp';
  // Table sort
  order: {
    timestamp?: number
  } = {
    timestamp: -1
  };
  reverse: boolean = false;
  collection: any[] = this.TradeHistoryColumns;
  sortedCollection: any[];

  tzlocal = moment.tz.guess();
  serverTimeOffset = moment.tz('America/New_York').utcOffset(); // -300  New York UTC-5 hours
  localTimeoffset = moment.tz(this.tzlocal).utcOffset();  // 60
  localDif = this.localTimeoffset / 60;
  timeOffset = (this.serverTimeOffset - this.localTimeoffset) / 60 + this.localDif; // 420 / 7
  timeOff = this.timeOffset * 60;

  currencyPairs: CurrencyDto[];

  currencyPairsJson: Json<string, CurrencyDto>;

  constructor(
    private httpService: HttpClient,
    private socketService: SocketService,
    private orderPipe: OrderPipe,
    private stateService: StateService,
    private dataexchangeService: DataexchangeService,
    private readonly store: Store<MatchBoardState>
  ) {
    this.sortedCollection = orderPipe.transform(this.collection, 'timestamp');
    this.subscriptions = new Array<Subscription>();
  }

  setOrder(value: string) {
    if (!Object.keys(this.order).includes(value) || this.order[value] === 0) {
      this.order[value] = 1;
      return;
    }

    if (this.order[value] === 1) {
      this.order[value] = -1;
      return;
    }
    this.order[value] = 0;
  }

  // Repeat empty <TR>
  Arr = Array;
  num:number = 5;

  ngOnInit() {
    this.subscriptions.push(
      this.dataexchangeService.trades.subscribe((trades) => {
        this.TradeHistoryColumns = trades;
      })
    );

    // this.socketService.onClientStateChanged().subscribe((state) => {
    //   if (state.trades) {
    //     this.TradeHistoryColumns = state.trades;
    //   }
    // });

    // this.TradeHistoryColumns = this.stateService.getTrades();
    this.store.select(getTradesSelector).subscribe((trades) => {
      this.TradeHistoryColumns = trades;
    });
    this.store.select(getCurrencyPairsSelector).subscribe((currencyPairs) => {
      this.currencyPairs = currencyPairs;
      this.currencyPairsJson = new Json(currencyPairs, 'sixLetterCode')
    });
  }

  getClass(property: string) {
    if (!this.order[property] || this.order[property] === 0) {
      return 'icon-with';
    }
    if (this.order[property] === -1) {
      return 'fa-chevron-up';
    }
    return 'fa-chevron-down';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getCountOfSwapPriceDecimal(trade: any) {
    let swapPrice;
    if (!trade.swapPrice) {
      const farLegToTrade = this.TradeHistoryColumns.find(t => t.tradeId === trade.tradeId.replace('NEAR', 'FAR'));
      swapPrice = farLegToTrade.swapPrice;
    } else {
      swapPrice = trade.swapPrice;
    }

    // TODO TEST! (HOTFIX)
    if (typeof swapPrice === 'undefined'  || swapPrice == null) {
      return '1.2';
    }
    //

    const pieces = swapPrice.toString().split('.');
    if (pieces[1]) {
      return '1.2-' + pieces[1].length;
    }
    return '1.2';
  }

  getPriceNumberPipe(trade: TradeHistoryColumns): string {
    const cpData = this.currencyPairs.find(cp => cp.sixLetterCode === trade.sixLetterCode);
    if (trade.swapLeg === 'NL') {
      return `1.${cpData.spotPricePrecision}-${cpData.spotPricePrecision}`;
    } else {
      return `1.${cpData.swapPricePrecision}-${cpData.swapPricePrecision}`;
    }
  }

  // getPrice(item: TradeHistoryColumns) {
  //   const cpData = this.stateService.getCurrencyPairs().find(cp => cp.sixLetterCode === item.sixLetterCode);
  //   if (item.swapLeg === 'NL') {
  //     return this.getFormattedPriceByPrecision(item.price, cpData.spotPricePrecision);
  //     // return item.price;
  //     // if (cpData.spotPricePrecision === 0) {
  //     //   return Number(item.price.toFixed(0));
  //     // } else {
  //     //   return Number(item.price.toFixed(cpData.spotPricePrecision - 1));
  //     // }
  //   } else {
  //     const nearLeg = this.TradeHistoryColumns.find(t => t.tradeId === item.tradeId.replace('FAR', 'NEAR'));
  //     // const formattedNearLegPrice = this.getFormattedPriceByPrecision(nearLeg.price, cpData.spotPricePrecision);
  //     // if (cpData.spotPricePrecision > 1) {
  //     //   return this.getFormattedPriceByPrecision(nearLeg.price, cpData.spotPricePrecision) + item.swapPrice;
  //     // }
  //     // return item.price;
  //     return this.getFormattedPriceByPrecision(nearLeg.price, cpData.spotPricePrecision) + item.swapPrice;
  //   }
  // }
  //
  // getFormattedPriceByPrecision(price: number, precision: number) {
  //   if (precision === 0) {
  //     return Math.ceil(price / 10) * 10;
  //   } else {
  //     return Number(price.toFixed(precision - 1));
  //   }
  // }
}
